// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"bbaee609","422":"16a352bd","499":"33b00bb5","931":"b0581afc"}[chunkId] + ".css";
};